// filepath: /Users/desarrollo/Documents/Proyectos/friax/src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import 'animate.css';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importar Bootstrap CSS
import 'bootstrap'; // Importar Bootstrap JavaScript
import '@fortawesome/fontawesome-free/css/all.css'; // Importar FontAwesome CSS
import './css/theme.css'; // Importar el archivo CSS global

createApp(App).use(router).mount('#app');